import type { ChatMessage } from '@/entities/chat'
import { systemMessageText } from './chatHelpers'

export function SystemMessageRow({ message }: { message: ChatMessage }) {
  const text = systemMessageText(message)
  if (!text) return null
  return (
    <div className="flex justify-center px-3 py-1.5">
      <span className="max-w-[80%] wrap-anywhere text-center text-[11.5px] text-ink-3">{text}</span>
    </div>
  )
}
